import React from "react";
import { ArrowLeft, PanelLeftClose, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/student/AITutorLayout/AITutorHeader/AITutorHeader.css";

const AITutorHeader = ({
  mode = "tutor",
  onModeChange,
  onToggleSidebar,
  onToggleContext,
  status = "active",
}) => {
  const navigate = useNavigate();
  const statusLabel = { active: "Active", thinking: "Thinking…", idle: "Idle" }[
    status
  ];

  return (
    <header className={`tch-header tch-header--${mode}`}>
      {/* ── LEFT ── */}
      <div className="tch-side tch-side--left">
        <button
          className="tch-btn"
          onClick={() => navigate("/")}
          aria-label="Back to home"
        >
          <ArrowLeft size={16} strokeWidth={2} />
        </button>

        {onToggleSidebar && (
          <button
            className="tch-btn tch-mobile-only"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
          >
            <PanelLeftClose size={16} strokeWidth={2} />
          </button>
        )}

        <span className="tch-logo-sep" aria-hidden="true" />
        <span className="tch-title">Techify AI</span>
      </div>

      {/* ── CENTER ── */}
      <div className="tch-center">
        <div className={`tch-status tch-status--${status}`} aria-live="polite">
          <span
            className={`tch-status-dot tch-status-dot--${status}`}
            aria-hidden="true"
          />
          <span className="tch-status-label">{statusLabel}</span>
        </div>
      </div>

      {/* ── RIGHT ── */}
      <div className="tch-side tch-side--right">
        <div className="tch-mode-toggle" role="group" aria-label="AI Mode">
          {/* sliding pill */}
          <span
            className={`tch-toggle-track ${mode === "buddy" ? "tch-toggle-track--buddy" : ""}`}
            aria-hidden="true"
          />

          <button
            className={`tch-mode-btn tch-mode-btn--tutor ${mode === "tutor" ? "is-active" : ""}`}
            onClick={() => onModeChange?.("tutor")}
            aria-pressed={mode === "tutor"}
          >
            <span className="tch-mode-dot" aria-hidden="true" />
            Tutor
          </button>
          <button
            className={`tch-mode-btn tch-mode-btn--buddy ${mode === "buddy" ? "is-active" : ""}`}
            onClick={() => onModeChange?.("buddy")}
            aria-pressed={mode === "buddy"}
          >
            <span className="tch-mode-dot" aria-hidden="true" />
            Buddy
          </button>
        </div>

        {onToggleContext && (
          <button
            className="tch-btn tch-btn--context"
            onClick={onToggleContext}
            aria-label="Learning Context"
          >
            <LayoutDashboard size={16} strokeWidth={2} />
          </button>
        )}
      </div>
    </header>
  );
};

export default AITutorHeader;
